<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      debugInfo: false, // 关闭调试信息显示
      currentRoute: '/',
      urlParams: ''
    }
  },
  mounted() {
    // 记录当前路由和URL参数
    this.currentRoute = window.location.pathname;
    this.urlParams = window.location.search;
    
    console.log('App组件已挂载');
    console.log('当前路由:', this.currentRoute);
    console.log('URL参数:', this.urlParams);
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>